import { render, staticRenderFns } from "./history.vue?vue&type=template&id=476f04b4"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=476f04b4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\site\\online-photo\\image-upscaler-spa\\aiseesoft.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476f04b4')) {
      api.createRecord('476f04b4', component.options)
    } else {
      api.reload('476f04b4', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=476f04b4", function () {
      api.rerender('476f04b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/history.vue"
export default component.exports